<script>
import { Line } from "vue-chartjs";

const fontColor = "#FFFFFF";
const axes = [
  {
    ticks: { fontColor },
    gridLines: { color: "rgba(255,255,255,0.1)" },
  },
];

export default {
  name: "StatisticChart",
  extends: Line,
  props: {
    height: {
      type: Number,
      default: 250,
    },
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor,
            fontSize: 14,
            fontStyle: "bold",
          },
        },
        scales: {
          xAxes: axes,
          yAxes: axes,
        },
      }),
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      },
    },
  },
};
</script>

<style>
/* .chart-wrapper {
  height: 260px;

  @media (max-width: 768px) {
    height: 180px;
  }
} */
</style>
